import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { TrendingUp, Eye, FileText, Users } from 'lucide-react';
import { MAY_SNAPSHOT, TOTALS, formatNum } from '../data';

const Row = ({ icon: Icon, iconColor, label, then, now }) => {
    const delta = now != null && then != null ? now - then : null;
    const pct = delta != null && then > 0 ? Math.round((delta / then) * 100) : null;

    return (
        <div className="grid grid-cols-[auto_1fr_auto_auto_auto] items-center gap-3 md:gap-6 py-4 border-b border-white/10 last:border-b-0">
            <div className={`${iconColor} p-2.5 rounded-xl inline-flex`}>
                <Icon size={18} />
            </div>
            <p className="text-white/70 text-sm font-semibold">{label}</p>
            <p className="text-white/40 font-mono text-sm text-right">{formatNum(then)}</p>
            <TrendingUp size={14} className="text-emerald-400" />
            <div className="text-right">
                <p className="text-white font-black text-lg tracking-tight">{formatNum(now)}</p>
                {pct != null && (
                    <span className="inline-flex items-center bg-emerald-500/15 text-emerald-300 text-[10px] font-bold px-2 py-0.5 rounded-full">
                        +{formatNum(delta)} ({pct >= 0 ? '+' : ''}{pct}%)
                    </span>
                )}
            </div>
        </div>
    );
};

export const ThenVsNow = () => {
    return (
        <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Since The Last Report</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    May 13 vs Today
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    What the network added in the 55 days since the {MAY_SNAPSHOT.label}.
                </p>

                <GlassCard>
                    <div className="px-2">
                        <div className="grid grid-cols-[auto_1fr_auto_auto_auto] items-center gap-3 md:gap-6 pb-3 border-b border-white/20">
                            <span />
                            <span className="text-white/30 text-[10px] uppercase tracking-widest font-bold">Metric</span>
                            <span className="text-white/30 text-[10px] uppercase tracking-widest font-bold text-right">May 13</span>
                            <span />
                            <span className="text-white/30 text-[10px] uppercase tracking-widest font-bold text-right">Jul 7</span>
                        </div>
                        <Row icon={Eye} iconColor="bg-blue-500/20 text-blue-300" label="Total Network Views" then={MAY_SNAPSHOT.views} now={TOTALS.views} />
                        <Row icon={FileText} iconColor="bg-purple-500/20 text-purple-300" label="Total Posts Published" then={MAY_SNAPSHOT.posts} now={TOTALS.posts} />
                        <Row icon={Users} iconColor="bg-emerald-500/20 text-emerald-300" label="Network Followers" then={MAY_SNAPSHOT.followers} now={TOTALS.followers} />
                    </div>
                </GlassCard>
            </div>
        </section>
    );
};
